import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SnackBarService {
    public snackBar$: Observable<any>;
    private snackBarSubject: Subject<any>;
  
    constructor() {
      this.snackBarSubject = new Subject<any>();
      this.snackBar$ = this.snackBarSubject.asObservable();
    }
  
    add(message: string, type: any, clickable: number = 0, duration: number = 3000) {
      var snackBarMessage = {
        message,
        type,
        clickable,
        duration
      }
      
      this.snackBarSubject.next(snackBarMessage);
    }
  }